

//create CRUD class with axios
import axios, { AxiosResponse } from 'axios';
import DataService from './dataservice.base';


export default class ReceiptDataService extends DataService {


    constructor(path :string) {
        super(path);
        
    }


     // GET a single record by ID
    async getByDate(startDate : string, tags:Array<Object>): Promise<AxiosResponse> {
        return await this.axios.get(`${this.apiUrl}${this.path}/${startDate}?storeId=${this.storeId}`);
    }

     // GET a single record by ID
     async getByRange(startDate : string, endDate : string ): Promise<AxiosResponse> {
        return await this.axios.get(`${this.apiUrl}${this.path}/${startDate}/${endDate}}?storeId=${this.storeId}`);
    }


    async getReportSummary(startDate : string, endDate : string, tags:Array<Object> ): Promise<AxiosResponse> {      
        let payload = {
            startDate: startDate,
            endDate: endDate,
            storeId: this.storeId,
            tags:tags   
        }
        
        return await this.axios.post(`${this.apiUrl}${this.path}/reports/summary`, payload);
    }

    async changePayment(receipt:object){    
        const url = `${this.apiUrl}${this.path}/change-payments`
        return await this.axios.put(url, receipt);
    }

    async markLiveReceipts(payload:any){
        const url = `${this.apiUrl}${this.path}/closeShop`
        return await this.axios.post(url, payload);
    }

    // async updateCustomGuest(receipt:object){
    //     //**** Please check url */
    //     const url = `${this.apiUrl}${this.path}/?storeId=${this.storeId}`
    //     return await this.axios.post(url, receipt);
    // }
    async updateCustomGuest(payload:object){
        //**** Please check url */
        const url = `${this.apiUrl}${this.path}/set-customers`
        return await this.axios.put(url, payload);
    }
}

// Nuxt auto-import (unimport) ลงทะเบียนชื่อคลาสนี้เป็น named export
// จึงต้อง export ชื่อออกไปด้วย ไม่งั้น build จะ resolve ไม่เจอ
// ส่วน default export ตัวเดิมยังอยู่ ผู้ที่ import แบบเดิมไม่กระทบ
export { ReceiptDataService };
